const STORAGE_KEY = 'tdsState'

export const TdsState = {
  // 状態の取得
  get() {
    const data = sessionStorage.getItem(STORAGE_KEY)
    return data ? JSON.parse(data) : null
  },

  // 決済3DS開始
  startPayment({ planId, returnPath }) {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        type: 'payment',
        planId,
        returnPath,
        handled: false,
      })
    )
  },

  // カード登録3DS開始
  startCardRegistration({ planId, paymentMethodId, returnPath }) {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        type: 'cardRegistration',
        planId,
        paymentMethodId,
        returnPath,
        handled: false,
      })
    )
  },

  // 購入オプション決済3DS/PayPay開始
  startPurchaseOptionPayment({
    resultId,
    selectedItem,
    returnPath,
    settlementId,
    paymentMethod,
  }) {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        type: 'purchaseOptionPayment',
        resultId,
        selectedItem,
        returnPath,
        settlementId,
        paymentMethod, // 'CREDIT_CARD' or 'PAYPAY'
        handled: false,
      })
    )
  },

  // 処理済みにマーク（重複防止）
  markHandled() {
    const state = this.get()
    if (state) {
      state.handled = true
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state))
    }
  },

  // クリア
  clear() {
    sessionStorage.removeItem(STORAGE_KEY)
  },
}
